import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useMakeProjectPublicMutation() {
    const { project } = useProject();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            const res = await apiClient.updateProject({
                params: { id: project.id },
                body: { collaborators: null },
            });
            if (res.status !== 200) {
                throw new Error("Failed to make project public");
            }
            return res.body;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["project", project.id] });
        },
    });
}
